import { useUrlParams } from '../../utils/url';
import DirectoryHeader from './DirectoryHeader';
import PatientInfoForm from './PatientInfoForm';
import Slots from './Slots';
import SlotConfirm from './SlotConfirm';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import { useDirectory } from 'src/contexts/DirectoryContext';
import { useState } from 'react';
import { Slot } from 'src/shared/types';
import Loading from '../Loading';
import Button from '../Button';
import StepIndicator from '../StepIndicator';

const SlotsPage = () => {
  const params = useUrlParams();
  const org_id = params.org_id;
  const { organization, practitioner, error, setError, loading } = useDirectory();
  const [ step, setStep ] = useState<number>(2);
  const [ selectedSlot, setSelectedSlot ] = useState<Slot | null>(null);
  const [ patientId, setPatientId ] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-gray-50">
      <DirectoryHeader hasSearched={true} />

      {error ? (
        <div className="flex flex-col items-center pt-4 h-screen bg-gradient-to-br from-red-50 to-red-100 px-4">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
            <div className="flex justify-center mb-6">
              <div className="bg-red-100 rounded-full p-4">
                <ExclamationCircleIcon className="w-12 h-12 text-red-600" />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Something went wrong</h2>
            <p className="text-red-600 text-lg mb-6 leading-relaxed">{error}</p>
            <Button
              onClick={() => {
                setError(null);
                window.location.href = `/${org_id}/practitioner/search`;
              }}
              text="Back to Search"
            />
          </div>
        </div>
      ) : loading || !organization || !practitioner ? (
        <Loading message="Loading Slots..." />
      ) : (
        <>
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 pt-4 sm:pt-8">
            <StepIndicator
              step={step}
              stepNames={['Search Providers', 'Select Time', 'Patient Information', 'Confirm Booking']}
              color="brand"
            />
          </div>
          {step === 4 && selectedSlot && patientId ? (
            <SlotConfirm
              organization={organization}
              selectedSlot={selectedSlot}
              selectedPractitioner={practitioner}
              patientId={patientId}
            />
          ) : step === 3 && selectedSlot ? (
            <PatientInfoForm
              onSubmit={(id) => {
                setPatientId(id);
                setStep(4);
              }}
              onBack={() => {
                setStep(2);
                setSelectedSlot(null);
              }}
            />
          ) : (
            <Slots
              organization={organization}
              selectedPractitioner={practitioner}
              onSlotSelect={(slot) => {
                setSelectedSlot(slot);
                setStep(3);
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default SlotsPage;

